/**
 * Audio Controller Class
 *
 * Handles the audio components
 *
 * Can be called by example: musicManager.onFreespinsIntro();
 *
 */
musicManager = {};
musicManager.idle = true;
musicManager.inFreespins = false;
musicManager.wasInFreespins = false;
musicManager.inBaseGameModifier = false;
musicManager.inBigWin = false;
musicManager.musicLevel = 1;
musicManager.maxMusicVolume = 1;

musicManager.ALLOFFLEVEL = [false, false, false, false];
musicManager.IDLELEVEL = [true, false, false, false];
musicManager.SPINLEVEL = [false, true, false, false];
musicManager.SINGLEWINLEVEL = [false, true, false, false];
musicManager.MULTIWINLEVEL = [false, false, true, false];
musicManager.REALLYBIGWINLEVEL = [false, false, false, true];

musicManager.FREESPINS_ALLOFF = [false, false, false];
musicManager.FREESPINS_BASE = [true, false, false];
musicManager.FREESPINS_LEVEL1 = [false, true, false];
musicManager.FREESPINS_LEVEL2 = [false, false, true];

// Base
musicManager.soundsToFadeOut = [];
musicManager.soundsToFadeIn = [];

musicManager.fadeInActive = false;
musicManager.fadeOutActive = false;

musicManager.fadeInTimer = undefined;
musicManager.fadeOutTimer = undefined;

musicManager.stepDownTimer = undefined;

// Freespins
musicManager.soundsToFadeOutFS = [];
musicManager.soundsToFadeInFS = [];

musicManager.fadeInActiveFS = false;
musicManager.fadeOutActiveFS = false;

musicManager.fadeInTimerFS = undefined;
musicManager.fadeOutTimerFS = undefined;

musicManager.currentBaseLevels = undefined;
musicManager.currentFSLevels = undefined;

musicManager.returnTimer = undefined;
musicManager.returnDelayTime = 8;

musicManager.returnIdleTimer = undefined;
musicManager.returnIdleTime = 1.5;

musicManager._anticipationSounds = [];

musicManager.initialise = function () {
  musicManager.volume = 0;
  musicManager.playing = false;
  musicManager.soundTags = soundManager.soundsConfig.tags;

  musicManager.fadeBaseTimeIn = 1000;
  musicManager.fadeBaseTimeOut = 2000;

  musicManager.fadeLevelTimeIn = 1500;
  musicManager.fadeLevelTimeOut = 2000;

  musicManager.fadeBigWinTimeIn = 1000;
  musicManager.fadeBigWinTimeOut = 1000;

  musicManager.fadeSymWinTimeIn = 300;
  musicManager.fadeSymWinTimeOut = 300;

  musicManager.baseMusic = [
    "mainTheme0",
    "mainTheme1",
    "mainTheme2",
    "mainTheme3",
  ];

  musicManager.basePlaying = [false, false, false, false, false];

  musicManager.baseID = [];

  musicManager.freeSpinsLevel = musicManager.FREESPINS_ALLOFF;

  musicManager.freeSpinsMusic = [
    "freeSpinsTheme0",
    "freeSpinsTheme1",
    "freeSpinsTheme2",
  ];

  musicManager.fsPlaying = [false, false, false, false];

  musicManager.freeSpinsID = [];

  musicManager.gambleThemeID;

  musicManager._anticipationSounds = [
    "anticipation1",
    "anticipation2",
    "anticipation3",
  ];
};

musicManager.onGameLoaded = function () {
  // setup base music tracks - all volumes 0
  for (var i = 0; i < musicManager.baseMusic.length; i++) {
    musicManager.baseID.push(soundManager.play(musicManager.baseMusic[i]));
    soundManager.setVolume(0, musicManager.baseID[i]);
  }

  // setup free spins music tracks - all volumes 0
  for (var j = 0; j < musicManager.freeSpinsMusic.length; j++) {
    musicManager.freeSpinsID.push(
      soundManager.play(musicManager.freeSpinsMusic[j])
    );
    soundManager.setVolume(0, musicManager.freeSpinsID[j]);
  }

  musicManager.gambleThemeID = soundManager.play("gambleTheme");
  soundManager.setVolume(0, musicManager.gambleThemeID);

  musicManager.fadeLevels(musicManager.IDLELEVEL, 0, 0, 1, 0);
};

musicManager.onGameStart = function () {
  musicManager.idle = false;
  musicManager.stepDownTimer = undefined;
  if (!musicManager.playing && !musicManager.inFreespins) {
    musicManager.playing = true;
    musicManager.fadeLevels(
      musicManager.SPINLEVEL,
      musicManager.fadeBaseTimeIn,
      musicManager.fadeBaseTimeOut,
      1,
      0
    );
  }
};

musicManager.onGameEnd = function () {
  musicManager.idle = true;
  musicManager.playing = false;
  if (
    !autoplayManager.isAutoplayEnabled() ||
    autoplayManager.getRemainingRounds() <= 0
  ) {
    musicManager.returnIdleTimer = gsap.delayedCall(
      musicManager.returnIdleTime,
      () => {
        musicManager.fadeLevels(
          musicManager.IDLELEVEL,
          musicManager.fadeBaseTimeIn,
          musicManager.fadeBaseTimeOut
        );
      }
    );
  }
};

musicManager.stepDown = function () {
  if (musicManager.basePlaying === musicManager.REALLYBIGWINLEVEL) {
    musicManager.stepDownTimer = timerManager.addTimer(
      4000,
      undefined,
      musicManager.stepDown
    );

    musicManager.fadeLevels(
      musicManager.MULTIWINLEVEL,
      musicManager.fadeBaseTimeIn,
      musicManager.fadeBaseTimeOut,
      1,
      0
    );
  } else if (musicManager.basePlaying === musicManager.MULTIWINLEVEL) {
    musicManager.stepDownTimer = timerManager.addTimer(
      4000,
      undefined,
      musicManager.stepDown
    );

    musicManager.fadeLevels(
      musicManager.SINGLEWINLEVEL,
      musicManager.fadeBaseTimeIn,
      musicManager.fadeBaseTimeOut,
      1,
      0
    );
  } else if (musicManager.basePlaying === musicManager.SINGLEWINLEVEL) {
    musicManager.stepDownTimer = timerManager.addTimer(
      4000,
      undefined,
      musicManager.stepDown
    );

    musicManager.fadeLevels(
      musicManager.SPINLEVEL,
      musicManager.fadeBaseTimeIn,
      musicManager.fadeBaseTimeOut,
      1,
      0
    );
  } else if (musicManager.basePlaying === musicManager.SPINLEVEL) {
    timerManager.stop(musicManager.stepDownTimer);

    musicManager.fadeLevels(
      musicManager.IDLELEVEL,
      musicManager.fadeBaseTimeIn,
      musicManager.fadeBaseTimeOut,
      1,
      0
    );
  }
};

musicManager.playBigWin = function () {
  musicManager.bigWinID = soundManager.play("bigWin");

  if (musicManager.inFreespins) {
    musicManager.fadeFSLevels(
      musicManager.FREESPINS_ALLOFF,
      musicManager.fadeBigWinTimeIn,
      musicManager.fadeBigWinTimeOut
    );
  } else {
    // /musicManager.stepDownTimer  = timerManager.addTimer(4000, undefined , musicManager.stepDown);
    musicManager.fadeLevels(
      musicManager.ALLOFFLEVEL,
      musicManager.fadeBigWinTimeIn,
      musicManager.fadeBigWinTimeOut,
      1,
      0
    );
  }
};

musicManager.fadeBigWinOut = function () {
  timerManager.addTimer(3000, musicManager.fadeBigWinLevelOut, () => {
    soundManager.stop("bigWin");
  });
};

musicManager.fadeBigWinLevelOut = function (progress) {
  if (soundManager.getSound(musicManager.bigWinID != null)) {
    soundManager.setVolume(1 - progress, musicManager.bigWinID);
  }
};

// Sets a prolong delay to return.
musicManager.restartReturnTimer = function () {
  if (musicManager.returnTimer) musicManager.returnTimer.restart();
};

/////////////////////////////////
// Pass in 5 item array - with levels that need to be on and off )
// e.g. F,F,T,T,F will play levels 2 and 3 ( indexed from 0 )
////////////////////////
musicManager.fadeLevels = function (
  levels,
  fadeInTime,
  fadeOutTime,
  volIn,
  volOut
) {
  // we must immediately jump to the end if we are fading in/out and another request comes in
  // stop doesn't call the finished call backs so do them manually here
  musicManager.currentBaseLevels = levels;

  if (musicManager.returnIdleTimer) {
    musicManager.returnIdleTimer.kill();
    musicManager.returnIdleTimer = undefined;
  }

  if (musicManager.returnTimer) {
    musicManager.returnTimer.kill();
    musicManager.returnTimer = undefined;
  }

  if (musicManager.fadeInActive) {
    timerManager.stop(musicManager.fadeInTimer);
    musicManager.fadeLevelsInFinished(musicManager.maxMusicVolume);
  }

  if (musicManager.fadeOutActive) {
    timerManager.stop(musicManager.fadeOutTimer);
    musicManager.fadeLevelsOutFinished(volOut);
  }

  // at end as we may not have a channel currently playing - musicManager.basePlaying = levels;
  musicManager.soundsToFadeOut = [];
  musicManager.soundsToFadeIn = [];

  musicManager.fadeInActive = false;
  musicManager.fadeOutActive = false;

  for (var i = 0; i < levels.length; i++) {
    if (levels[i] === true && musicManager.basePlaying[i] === false) {
      // we want to play but it's currently silent - fade in level
      musicManager.soundsToFadeIn.push(musicManager.baseID[i]);
      musicManager.fadeInActive = true;
    } else if (levels[i] === false && musicManager.basePlaying[i] === true) {
      // currently playing but make silent
      musicManager.soundsToFadeOut.push(musicManager.baseID[i]);
      musicManager.fadeOutActive = true;
    }
  }

  musicManager.fadeInTimer = timerManager.addTimer(
    fadeInTime,
    musicManager.fadeLevelsIn,
    musicManager.fadeLevelsInFinished(musicManager.maxMusicVolume)
  );
  musicManager.fadeOutTimer = timerManager.addTimer(
    fadeOutTime,
    musicManager.fadeLevelsOut,
    musicManager.fadeLevelsOutFinished(volOut)
  );

  musicManager.basePlaying = levels;
};

musicManager.fadeFSLevels = function (levels, fadeInTime, fadeOutTime) {
  // we must immediately jump to the end if we are fading in/out and another request comes in
  // stop doesn't call the finished call backs so do them manually here
  if (levels == musicManager.currentFSLevels) return;
  musicManager.freeSpinsLevel = levels;
  musicManager.currentFSLevels = levels;

  if (musicManager.returnIdleTimer) {
    musicManager.returnIdleTimer.kill();
    musicManager.returnIdleTimer = undefined;
  }

  if (musicManager.returnTimer) {
    musicManager.returnTimer.kill();
    musicManager.returnTimer = undefined;
  }

  if (musicManager.fadeInActiveFS) {
    timerManager.stop(musicManager.fadeInTimerFS);
    musicManager.fadeLevelsInFinishedFS();
  }

  if (musicManager.fadeOutActiveFS) {
    timerManager.stop(musicManager.fadeOutTimerFS);
    musicManager.fadeLevelsOutFinishedFS();
  }

  // at end as we may not have a channel currently playing - musicManager.fsPlaying = levels;
  musicManager.soundsToFadeOutFS = [];
  musicManager.soundsToFadeInFS = [];

  musicManager.fadeInActiveFS = false;
  musicManager.fadeOutActiveFS = false;

  for (var i = 0; i < levels.length; i++) {
    if (levels[i] === true && musicManager.fsPlaying[i] === false) {
      // we want to play but it's currently silent - fade in level
      musicManager.soundsToFadeInFS.push(musicManager.freeSpinsID[i]);
      musicManager.fadeInActiveFS = true;
    } else if (levels[i] === false && musicManager.fsPlaying[i] === true) {
      // currently playing but make silent
      musicManager.soundsToFadeOutFS.push(musicManager.freeSpinsID[i]);
      musicManager.fadeOutActiveFS = true;
    }
  }

  musicManager.fadeInTimerFS = timerManager.addTimer(
    fadeInTime,
    musicManager.fadeLevelsInFS,
    musicManager.fadeLevelsInFinishedFS
  );
  musicManager.fadeOutTimerFS = timerManager.addTimer(
    fadeOutTime,
    musicManager.fadeLevelsOutFS,
    musicManager.fadeLevelsOutFinishedFS
  );

  musicManager.fsPlaying = levels;
};

// BASE VERSIONS

musicManager.fadeLevelsIn = function (progress) {
  for (var i = 0; i < musicManager.soundsToFadeIn.length; i++) {
    soundManager.setVolume(
      progress * musicManager.maxMusicVolume,
      musicManager.soundsToFadeIn[i]
    );
  }
};

musicManager.fadeLevelsOut = function (progress) {
  for (var i = 0; i < musicManager.soundsToFadeOut.length; i++) {
    soundManager.setVolume(
      musicManager.maxMusicVolume - progress * musicManager.maxMusicVolume,
      musicManager.soundsToFadeOut[i]
    );
  }
};

musicManager.fadeLevelsInFinished = function (volume) {
  for (var i = 0; i < musicManager.soundsToFadeIn.length; i++) {
    soundManager.setVolume(volume, musicManager.soundsToFadeIn[i]);
  }
  musicManager.fadeInActive = false;
};

musicManager.fadeLevelsOutFinished = function (volume) {
  for (var i = 0; i < musicManager.soundsToFadeOut.length; i++) {
    soundManager.setVolume(volume, musicManager.soundsToFadeOut[i]);
  }

  musicManager.fadeOutActive = false;
};

// FREESPIN VERSIONS
musicManager.fadeLevelsInFS = function (progress) {
  for (var i = 0; i < musicManager.soundsToFadeInFS.length; i++) {
    soundManager.setVolume(
      progress * musicManager.maxMusicVolume,
      musicManager.soundsToFadeInFS[i]
    );
  }
};

musicManager.fadeLevelsOutFS = function (progress) {
  for (var i = 0; i < musicManager.soundsToFadeOutFS.length; i++) {
    soundManager.setVolume(
      musicManager.maxMusicVolume - progress * musicManager.maxMusicVolume,
      musicManager.soundsToFadeOutFS[i]
    );
  }
};

musicManager.fadeLevelsInFinishedFS = function (progress) {
  for (var i = 0; i < musicManager.soundsToFadeInFS.length; i++) {
    soundManager.setVolume(
      musicManager.maxMusicVolume,
      musicManager.soundsToFadeInFS[i]
    );
  }

  musicManager.fadeInActiveFS = false;
};

musicManager.fadeLevelsOutFinishedFS = function (progress) {
  for (var i = 0; i < musicManager.soundsToFadeOutFS.length; i++) {
    soundManager.setVolume(0, musicManager.soundsToFadeOutFS[i]);
  }

  musicManager.fadeOutActiveFS = false;
};

musicManager.restartBaseMusic = function () {
  musicManager.fadeLevels(
    musicManager.IDLELEVEL,
    musicManager.fadeBaseTimeIn,
    musicManager.fadeBaseTimeOut,
    1,
    0
  );
};

musicManager.restartFreeSpins = function () {
  musicManager.fadeFSLevels(
    musicManager.freeSpinsLevel,
    musicManager.fadeBaseTimeIn,
    musicManager.fadeBaseTimeOut
  );
};

musicManager.onFreeSpinsCollected = function () {
  musicManager.fadeLevels(
    musicManager.ALLOFFLEVEL,
    musicManager.fadeBaseTimeIn,
    musicManager.fadeBaseTimeOut,
    1,
    0
  );
  soundManager.play("onFreeSpinsCollected", () => {
    musicManager.onFreespinsStart();
  });
};

musicManager.onFreespinsStart = function () {
  musicManager.onGambleEnd();

  // Here we stop the freespins intro music and play the freespins standard music
  timerManager.stop(musicManager.stepDownTimer);

  for (var i = 0; i < musicManager.baseMusic.length; i++) {
    soundManager.setVolume(0, musicManager.baseID[i]);
  }

  musicManager.freeSpinsLevel = musicManager.FREESPINS_BASE;
  musicManager.fadeFSLevels(
    musicManager.freeSpinsLevel,
    musicManager.fadeBaseTimeIn,
    musicManager.fadeBaseTimeOut
  );

  musicManager.inFreespins = true;
  musicManager.playing = false;
};

musicManager.freeSpinsNextLevel = function () {
  let newLevel;
  if (musicManager.freeSpinsLevel === musicManager.FREESPINS_BASE) {
    newLevel = musicManager.FREESPINS_LEVEL1;
  } else if (musicManager.freeSpinsLevel === musicManager.FREESPINS_LEVEL1) {
    newLevel = musicManager.FREESPINS_LEVEL2;
  } else newLevel = musicManager.freeSpinsLevel;
};

musicManager.onFreespinsEnd = function () {
  // Here we stop the freespins music. Normal music will be resumed upon next spin
  musicManager.inFreespins = false;
  musicManager.wasInFreespins = true;
  musicManager.fadeFSLevels(
    musicManager.FREESPINS_ALLOFF,
    musicManager.fadeBaseTimeIn,
    musicManager.fadeBaseTimeOut
  );
};

musicManager.onFreespinsLostGambleEnd = function () {
  // Here we stop the freespins music. Normal music will be resumed upon next spin
  musicManager.inFreespins = false;
  musicManager.fadeLevels(
    musicManager.IDLELEVEL,
    musicManager.fadeBaseTimeIn,
    musicManager.fadeBaseTimeOut,
    1,
    0
  );

  musicManager.onGambleEnd();
};

musicManager.onGambleStart = function () {
  musicManager.fadeLevels(
    musicManager.ALLOFFLEVEL,
    musicManager.fadeBaseTimeIn,
    musicManager.fadeBaseTimeOut,
    1,
    0
  );

  timerManager.addTimer(
    musicManager.fadeBaseTimeIn,
    (volume) => {
      soundManager.setVolume(volume, musicManager.gambleThemeID);
    },
    () => {
      soundManager.setVolume(
        musicManager.maxMusicVolume,
        musicManager.gambleThemeID
      );
    }
  );
};

musicManager.onGambleEnd = function () {
  timerManager.addTimer(
    musicManager.fadeBaseTimeOut,
    (volume) => {
      soundManager.setVolume(1 - volume, musicManager.gambleThemeID);
    },
    () => {
      soundManager.setVolume(0, musicManager.gambleThemeID);
    }
  );
};
musicManager.setMusicLevel = function (level) {
  musicManager.musicLevel = level;
};

musicManager.update = function (delta) {
  // Are we playing a sound
  if (musicManager.inFreespins) return;
};

musicManager.onRestorePreviouslyPlayingAudio = function (data) {
  if (data.reason === "back from replay" && !Reflex.replayGame) {
    musicManager.basePlaying = [false, false, false, false, false];
    musicManager.baseID = [];
    musicManager.fsPlaying = [false, false, false, false];
    musicManager.freeSpinsID = [];
    musicManager.onGameLoaded();
    musicManager.fadeLevelsInFinished(musicManager.maxMusicVolume);
    musicManager.stopAllTimers();
    musicManager.soundsToFadeOut = [];
    musicManager.soundsToFadeIn = [];
    musicManager.soundsToFadeOutFS = [];
    musicManager.soundsToFadeInFS = [];
  }
};

musicManager.stopAllTimers = function () {
  if (musicManager.returnIdleTimer) {
    musicManager.returnIdleTimer.kill();
    musicManager.returnIdleTimer = undefined;
  }

  if (musicManager.returnTimer) {
    musicManager.returnTimer.kill();
    musicManager.returnTimer = undefined;
  }

  if (musicManager.fadeInActive) {
    timerManager.stop(musicManager.fadeInTimer);
    musicManager.fadeInActive = false;
  }

  if (musicManager.fadeOutActive) {
    timerManager.stop(musicManager.fadeOutTimer);
    musicManager.fadeOutActive = false;
  }

  if (musicManager.fadeInActiveFS) {
    timerManager.stop(musicManager.fadeInTimerFS);
    musicManager.fadeInActiveFS = false;
  }

  if (musicManager.fadeOutActiveFS) {
    timerManager.stop(musicManager.fadeOutTimerFS);
    musicManager.fadeOutActiveFS = false;
  }
};

musicManager.onGoingToReplay = function () {
  // we may have some of our own tweens still running ffs
  musicManager.stopAllTimers();
};

musicManager.playAnticipationSound = function () {
  const soundIndex = gameController.numOfBonusSymbolsLanded - 2;
  const sound = musicManager._anticipationSounds[soundIndex];
  if (sound != null) {
    soundManager.play(sound);
  }
};

Reflex.addToUpdate(musicManager.update);

Reflex.registerInitialiseManager(musicManager.initialise);

messageBus.subscribe(
  "sounds:restorePreviouslyPlayingAudio",
  musicManager.onRestorePreviouslyPlayingAudio
);
messageBus.subscribe("game:goingToReplay", musicManager.onGoingToReplay);
